<template>
  <div class="service-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.serviceTitle') }}</h1>
      <slot name="app-desc"></slot>
      <p>{{ $t('common.service01') }}<a href="./privacy.html" target="_blank">{{ $t('common.service02') }}</a>{{ $t('common.service03') }}</p>
      <p>{{ $t('common.service04') }}</p>
      <h2>{{ $t('common.service05') }}</h2>
      <p>{{ $t('common.service06', { company: companyName }) }}</p>
      <h2>{{ $t('common.service07') }}</h2>
      <p>{{ $t('common.service08') }}</p>
      <p>{{ $t('common.service09') }}</p>
      <h2>{{ $t('common.service10') }}</h2>
      <p>{{ $t('common.service11') }}</p>
      <p>{{ $t('common.service12') }}</p>
      <h2>{{ $t('common.service13') }}</h2>
      <p>{{ $t('common.service14') }}</p>
      <p>{{ $t('common.service15') }}</p>
      <p>{{ $t('common.service16') }}</p>
      <h2>{{ $t('common.service17') }}</h2>
      <p>{{ $t('common.service18') }} <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>{{ $t('common.service19') }}</p>
      <p>{{ $t('common.service20') }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
  companyName: {
    type: String,
    required: true,
  },
  contactEmail: {
    type: String,
    required: true,
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.serviceTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
</style>
